<template>
    <div>
        <edit-link-dialog
            v-model="show_dialog"
            :modelProp="selected"
            :linkCategories="linkCategories"
            @successful-save="refreshData"
            @successful-delete="refreshData"
        />

        <div class="tw-flex tw-flex-col tw-gap-4 tw-p-1">

            <internal-table-section
                section-title="Links" button-text="Add Link"
                @button-clicked="addItem"
                class="tw-w-full"
                default_class="false"
            >
                <v-card id="table_about_us_card" class="d-flex flex-row container-fluid" flat>
                    <v-card-text class="pa-0 d-block">
                        <div class="px-7">
                            <v-layout child-flex>
                                <smart-table
                                    id="table_links"
                                    class="row-pointer"
                                    endpoint="resources.list"
                                    :headers="headers"
                                    flat
                                    @click:row="showItem"
                                    ref="list"
                                >
                                    <!-- <template v-slot:item.link="{ item }">
                                        <a target="_blank" :href="item.link">{{ item.link }}</a>
                                    </template> -->
                                </smart-table>
                            </v-layout>
                        </div>
                    </v-card-text>
                </v-card>
            </internal-table-section>

        </div>
    </div>

</template>

<script>
import EditLinkDialog from "@/Modals/EditLinkDialog.vue";
import InternalTableSection from "@/Generic/InternalTableSection";
import SmartTable from "@/Generic/SmartTable";

export default {
    name: "WebsiteContentLinks",
    components: {
        EditLinkDialog,
        InternalTableSection,
        SmartTable
    },
    props: {
        'linkCategories': {
            // Only specified at source parent component
        },
    },
    data() {
        return {
            show_dialog: false,
            selected: null,
            headers: [
                {
                    text: "Category",
                    align: "left",
                    sortable: true,
                    value: "category"
                },
                {
                    text: "Name",
                    align: "left",
                    sortable: true,
                    value: "name"
                },
                {
                    text: "Link",
                    align: "left",
                    sortable: true,
                    value: "link"
                },
            ]
        }
    },
    mounted() {
        //
    },
    computed: {
        //
    },
    methods: {
        refreshData() {
            this.$refs.list.refreshList()
        },
        showItem(item) {
            this.selected = item
            this.show_dialog = true
        },
        addItem() {
            this.selected = null
            this.show_dialog = true
        },
    }
}
</script>
<style scoped>
.description {
    font-size: 0.9em;
}
</style>
